export const RADIOGRAPHIC_FINDINGS_COUNT = 8;
